import { render, staticRenderFns } from "./GameInstance.vue?vue&type=template&id=40225526&scoped=true&"
import script from "./GameInstance.vue?vue&type=script&lang=js&"
export * from "./GameInstance.vue?vue&type=script&lang=js&"
import style0 from "./GameInstance.vue?vue&type=style&index=0&id=40225526&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40225526",
  null
  
)

export default component.exports